import React, { useState } from 'react';
import axios from 'axios';
import { URL_IMG_UPLOAD } from '../constants/sources.js';

const ImageUpload = ({ userId, onUploadStatusUpdate }) => {
  const [image, setImage] = useState(null);
  const [error, setError] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Vérification de la taille du fichier (5MB)
      if (file.size > 5 * 1024 * 1024) {
        setError('File size exceeds 5MB');
        setImage(null);
        return;
      }

      // Vérification du type de fichier
      const filetypes = /jpeg|jpg|png/;
      const extname = filetypes.test(file.name.split('.').pop().toLowerCase());
      if (!extname) {
        setError('File type not supported. Please upload a JPEG, JPG, or PNG file.');
        setImage(null);
        return;
      }

      setImage(file);
      setError(null);
    }
  };

  const handleUpload = async () => {
    if (image) {
      const formData = new FormData();
      formData.append('image', image);
      //   formData.append('userId', userId); // Ajouter l'ID utilisateur au formulaire
      //   console.log('userId:',userId);

      try {
        const response = await axios.post(`${URL_IMG_UPLOAD}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'userId': userId,
          },
        });
        onUploadStatusUpdate(response.data.fileName); // Mettre à jour l'état du parent
        // console.log('Image uploaded successfully:', response.data);
      } catch (error) {
        if (error.response) {
          // Le serveur a répondu avec un statut différent de 2xx
          console.error('Error response:', error.response.data);
          console.error('Error status:', error.response.status);
          console.error('Error headers:', error.response.headers);
        } else if (error.request) {
          // La requête a été faite mais aucune réponse n'a été reçue
          console.error('Error request:', error.request);
        } else {
          // Quelque chose s'est mal passé lors de la configuration de la requête
          console.error('Error message:', error.message);
        }
        console.error('Error config:', error.config);
        setError('Erreur. Verifiez la taille et le type de fichier (max 5Mo, jpg, jpeg, png).');
        onUploadStatusUpdate('error'); // Mettre à jour l'état du parent
      }
    }
  };

  return (
    <>
      <div className='row'>
        <div className='col-8'>
          <p><input type="file" accept="image/*" onChange={handleImageChange} /></p>
        </div>
      </div>
      <div className='row'>
        <div className='col-7'>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {!error && <p style={{ color: '#333333' }}>N'oubliez pas d'enregistrer la modification après le téléchargement</p>}
        </div>
        <div className='col-4'>
          <div onClick={handleUpload} className='btn btn-primary' title="Modifier l'image (n'oubliez pas d'enregistrer après)"><i className="fa-solid fa-file-export" style={{ marginRight: '5px' }}></i><i className="fa-solid fa-image"></i></div>
        </div>

      </div>
    </>
  );
};

export default ImageUpload;